import { NgModule } from '@angular/core';
import { CommonModule, SlicePipe } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { ValidateRolesDirective } from './directives/validateRoles/validate-roles.directive';
import { HasPermissionDirective } from 'src/app/servicios/permissions/hasPermission.directive';
import { GenericTableComponent } from './shared/components/generic-table/generic-table.component';
import { configuracion } from 'src/configuracion';
import { GenericTableHeaderComponent } from './shared/components/generic-table-header/generic-table-header.component';
import { AudioRecorderComponent } from './shared/components/audio-recorder/audio-recorder.component';
import { SortListMunicipalitiesPipe } from './pipe/sort-list-municipalities/sort-list-municipalities.pipe';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CityTimezoneDatePipe } from './pipe/city-timezone-date/city-timezone-date.pipe';
import { DisableIfNoPermissionDirective } from '../servicios/permissions/disable-if-no-permission.directive';
import { ConfigureGridComponent } from './shared/components/configure-grid/configure-grid.component';


export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, configuracion.translations_URL);
}

@NgModule({
    imports: [
        CommonModule,
        MatPaginatorModule,
        MatTableModule,
        MatTooltipModule,
        MatIconModule,
        MatSortModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatDividerModule,
        MatDialogModule,
        MatGridListModule,
        MatSelectModule,
        MatMenuModule,
        MatChipsModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        HasPermissionDirective,
        DisableIfNoPermissionDirective,
        CityTimezoneDatePipe,
        SlicePipe,
        TranslateModule.forChild({
            extend: true,
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
    ],
    declarations: [
        ValidateRolesDirective,
        GenericTableComponent,
        GenericTableHeaderComponent,
        AudioRecorderComponent,
        SortListMunicipalitiesPipe,
        ConfigureGridComponent
    ],
    exports: [
        ValidateRolesDirective,
        GenericTableComponent,
        GenericTableHeaderComponent,
        AudioRecorderComponent,
        SortListMunicipalitiesPipe,
        ConfigureGridComponent
    ],
})
export class UtilsModule {}